/**
 * defa.views.UserPasswordForm
 * A view for changing the user's password.
 * @version 1.2.0
 */
import Form from 'scripts/poppet/form';
import template from 'templates/userPasswordForm.jst.html';

const channelUser = Bb.Radio.channel( 'user' );

const selectors = {
	inputPasswordOld : '[data-input^=password-old]',
	inputPasswordsNew: '[data-input^=password-new-]',
	inputPassword1   : '[data-input=password-new-1]',
	inputPassword2   : '[data-input=password-new-2]',
	textPassword     : '[data-text=password-password]',
};

const UserPasswordForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template      : template,
	submitReaction: 'close',
	
	ui: {
		passwordOld : selectors.inputPasswordOld,
		passwords   : selectors.inputPasswordsNew,
		password1   : selectors.inputPassword1,
		password2   : selectors.inputPassword2,
		textPassword: selectors.textPassword,
	},
	
	templateContext: function () {
		return {
			oldPassRequired: ( this.userIsTechnicalSupport() ) ? 'disabled' : 'required',
		};
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Setup ui-listeners on render.
	 * @void
	 */
	onRender: function () {
		
		let self = this;
		
		// TODO: Move matching field validator to it's own behavior? ( this code is not dry, see
		// view-user-create-view.js ) email-addresses, passwords etc should be typed twice.
		let passwordListenerSetup = function ( p1, p2 ) {
			// turn off the "other" focus listener
			p2.off( 'focus' );
			
			// check on password matching length, if passwords are valid.
			p2.on( 'input', function () {
				
				if ( p1.val().trim().length === p2.val().trim().length ) {
					// turn off listeners that get's to this point.
					p2.off( 'blur' ).off( 'input' );
					
					// from this point on, trigger on each input change.
					self.ui.passwords.on( 'input', function () {
						self.doPasswordFeedback();
					} );
					self.doPasswordFeedback();
				}
			} );
			
			// check on leaving password field, if passwords are valid.
			p2.one( 'blur', function () {
				// turn off listeners that get's to this point.
				p2.off( 'input' );
				
				// from this point on, trigger on each input change.
				self.ui.passwords.on( 'input', function () {
					self.doPasswordFeedback();
				} );
				self.doPasswordFeedback();
			} );
		};
		// trigger which password field was visited first.
		self.ui.password1.one( 'focus', function () {
			passwordListenerSetup( self.ui.password1, self.ui.password2 );
		} );
		self.ui.password2.one( 'focus', function () {
			passwordListenerSetup( self.ui.password2, self.ui.password1 );
		} );
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Checks if the currently logged in user is technical support.
	 * @return {boolean}  True if the user has the role TECHINCAL_SUPPORT, false if not.
	 */
	userIsTechnicalSupport: function () {
		let user = channelUser.request( 'model' );
		
		return user.hasRoles( [ 'TECHNICAL_SUPPORT', ] );
	},
	
	/**
	 * Adjusts feedback for matching passwords.
	 * @void
	 */
	doPasswordFeedback: function () {
		let passwords = this.ui.passwords,
			feedback  = this.ui.textPassword;
		
		if ( !this.validatePasswords() ) {
			this.disableSubmit();
			passwords.addClass( 'error' );
			feedback
				.removeClass( 'fade-out' )
				.removeClass( 'hidden' )
				.addClass( 'fade-in' );
		} else {
			this.enableSubmit();
			passwords.removeClass( 'error' );
			feedback
				.removeClass( 'fade-in' )
				.addClass( 'fade-out' );
			
			setTimeout( function () {
				if ( feedback.hasClass( 'fade-out' ) ) {
					feedback.addClass( 'hidden' );
				}
			}, 1000 );
		}
	},
	
	/**
	 * Validates the password-fields.
	 * @return {bool} True if the passwords match, false if not.
	 */
	validatePasswords: function () {
		let password1 = this.ui.password1.val().trim(),
			password2 = this.ui.password2.val().trim();
		
		return ( password1 === password2 );
	},
	
	/**
	 * Validates the create form.
	 * @return {bool} True if the form validates, false if not.
	 */
	validate: function () {
		return this.validatePasswords();
	},
	
	/**
	 * Trigger all feedbackfunctions in the form.
	 * @void
	 */
	feedback: function () {
		this.doPasswordFeedback();
	},
	
	/**
	 * Checks if the form seems to be valid, and then attempts to submit it.
	 * @void
	 */
	submit: function () {
		let passOld = this.ui.passwordOld.val().trim(),
			pass1   = this.ui.password1.val().trim();
		
		this.model.changePassword( {
			oldPassword: passOld,
			newPassword: pass1
		} );
	},
	
	
} );

export default UserPasswordForm;